import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState, useRef } from "react";
import { QRCode } from "react-qrcode-logo";
import Button from "../../Button";
import Close from "../../Icons/Close";
import Loader from "../../Loader";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function QrCodeModal({ isOpen, setIsOpen }: Props) {
  const [isFetching, setIsFetching] = useState(false);
  const qrCodeRef = useRef<HTMLSpanElement>(null);

  const handleQrCodeDownload = () => {
    setIsFetching(true);

    const canvas = qrCodeRef.current?.querySelector("canvas");
    if (canvas) {
      const imageUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = imageUrl;
      downloadLink.download = "qr-code.png";
      downloadLink.click();
    }

    setIsFetching(false);
    setIsOpen(false);
  };
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-40 overflow-y-auto"
          onClose={() => setIsOpen(false)}
        >
          <div className="flex md:items-end items-center justify-center min-h-screen pt-4 px-4 pb-0 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-overlay bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block align-bottom bg-white dark:bg-navyGray rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle px-8 font-ubuntu">
                <div className="bg-white dark:bg-navyGray p-4 border-b border-frescoWhite dark:border-matteGray">
                  <div className="flex justify-between items-center">
                    <p className="font-medium text-lg text-black dark:text-frescoWhite">
                      QR Code
                    </p>
                    <span
                      className="bg-frescoWhite p-9px rounded-full cursor-pointer"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      <Close />
                    </span>
                  </div>
                </div>

                <div>
                  <div className="px-4 pt-2">
                    <div>
                      {" "}
                      <span ref={qrCodeRef} onClick={handleQrCodeDownload}>
                        <QRCode value={window.location.href} />
                      </span>
                    </div>
                  </div>
                  <div className="px-4 py-3 flex justify-between flex-row-reverse ">
                    {isFetching ? (
                      <Loader />
                    ) : (
                      <Button
                        onClick={handleQrCodeDownload}
                        size="vibhut-sm"
                        variant="vibhut-primary"
                      >
                        Download
                      </Button>
                    )}
                    <div className="mr-3">
                      <Button
                        size="vibhut-sm"
                        variant="vibhut-secondary"
                        onClick={() => setIsOpen(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
